var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 3c1.1555556 0 2.1333333.756 2.5066667 1.8h3.7155555c.9777778 0 1.7777778.81 1.7777778 1.8v12.6c0 .99-.8 1.8-1.7777778 1.8h-12.44444442c-.12444445 0-.24-.009-.35555556-.027-.34666666-.072-.65777778-.252-.89777778-.495-.16-.171-.29333333-.36-.38222222-.576s-.14222222-.459-.14222222-.702v-12.6c0-.252.05333333-.486.14222222-.693.08888889-.216.22222222-.414.38222222-.576.24-.243.55111112-.423.89777778-.495.11555556-.027.23111111-.036.35555556-.036h3.71555555c.37333334-1.044 1.35111107-1.8 2.50666667-1.8zm6.2222222 3.6h-12.44444442v12.6h12.44444442zm-4.4444444 9v1.8h-6.22222224v-1.8zm2.6666666-3.6v1.8h-8.88888884v-1.8zm0-3.6v1.8h-8.88888884v-1.8zm-4.4447311-3.825c-.3644445 0-.6666667.306-.6666667.675s.3022222.675.6666667.675c.3644444 0 .6666666-.306.6666666-.675s-.3022222-.675-.6666666-.675z",
    fill: "current",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.8fc0a51c81d0a90028e6ddadbe9d27b7.svg";
export { ForwardRef as ReactComponent };